export const QUANTITY_ROWS_IN_OPERATIONS = 10;

/* debounce para request usando un input */
export const KEYBOARD_DEBOUNCE = 1000;

/* configuration for sentry */
export const PROJECT_ID = "1453458";
